<template>
  <div class="veda-cooperation">
    <div class="web-box12 cooperation-content">
      <screen class="screen" @select="screenTag"></screen>
      <div v-if="loading" class="loading">
        <a-spin />
      </div>
      <div v-for="item in list" @click="goToDetail(item.id)" :key="item.id" class="card">
        <div class="banner" :style="{backgroundImage:`url(${item.cover})`}">
          <div class="tag">
            <!-- <p>食品饮料类&emsp;饮料 | 微博热搜榜</p> -->
          </div>
        </div>
        <p class="title">{{item.title}}</p>
        <div class="brand">
          <img :src="item.icon" />
          <p>{{item.brand}}</p>
          <!-- <p class="font10">2019.10.15-2019.10.16投放</p> -->
        </div>
      </div>
    </div>
    <div style="width:100%;text-align:center;margin-top:20px;">
      <a-pagination v-model="page" @change="pagination" :total="total" />
    </div>
  </div>
</template>
<script>
import screen from "@/components/screen";
export default {
  components: {
    screen
  },
  data() {
    return {
      list: [],
      page: 1,
      total: 1,
      industry_id: "",
      loading: true
    };
  },
  mounted() {
    this.query();
  },
  methods: {
    query() {
      this.loading = true;
      this.$jsonp(
        `http://h5.vedamobi.com/index.php/api/api/get_case?page=${this.page}&industry_id=${this.industry_id}`,
        {},
        (error, data) => {
          this.loading = false;
          if (data && data.code === 200) {
            this.total = data.total;
            this.list = data.data;
          } else {
            this.$message.error(`${error},${data.msg}`);
          }
        }
      );
    },
    screenTag(data) {
      let id;
      if (!data) {
        id = "";
      } else {
        id = data.id;
      }
      this.page = 1;
      this.industry_id = id;
      this.query();
    },
    goToDetail(id) {
      this.$router.push({
        path: "cooperDetail",
        query: { id }
      });
    },
    pagination() {
      this.query();
    }
  }
};
</script>
<style lang="scss" scoped>
.web-box12 {
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
}
.cooperation-content {
  display: flex;
  flex-wrap: wrap;
  .screen {
    margin: 80px 0 0 20px;
  }
  .card {
    border: 1px solid #f1f1f1;
    width: calc(25% - 16px);
    margin-top: 16px;
    margin-left: 16px;
    background-color: #fff;
    padding-bottom: 10px;
    border-radius: 7px;
    overflow: hidden;
    transition: all 0.2s ease-out;
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
    }
    .banner {
      width: 100%;
      height: 164px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50%;
      position: relative;
      .tag {
        color: #fff;
        padding: 12px 12px 8px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background-image: linear-gradient(
          to top,
          rgba(0, 0, 0, 0.4),
          transparent
        );
        p {
          margin: 0;
        }
      }
    }
    .title {
      font-size: 16px;
      margin: 0;
      width: 100%;
      padding: 6px 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      &:hover {
        color: #8899f2;
      }
    }
    .brand {
      margin: 0 12px;
      img {
        width: 28px;
        height: 28px;
        border-radius: 100%;
        float: left;
      }
      p {
        position: relative;
        left: 14px;
        line-height: 28px;
        margin: 0;
      }
      p:nth-child(2) {
        font-size: 14px;
      }
      p:nth-child(3) {
        font-size: 12px;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .cooperation-content {
    display: flex;
    .card {
      width: 100%;
      margin-left: 0;
    }
    .screen {
      margin: 80px 0 0 0px;
    }
  }
}
@media screen and (min-width: 577px) and (max-width: 992px) {
  .cooperation-content {
    display: flex;
    .card {
      width: calc(50% - 20px);
    }
  }
}
@media screen and (min-width: 993px) and (max-width: 1200px) {
  .cooperation-content {
    display: flex;
    .card {
      width: calc(33% - 20px);
    }
  }
}
</style>